import { IS_SPECIAL_DEPLOY } from "../config/global"

// 每次返回的最大消息数量
export const MES_REQ_NUM = 20

// 消息的内容标记空值
export const MARKED_NULL = '•'

// 提示图片内容回复为空
export const MARKED_NULL_REPLY = '抱歉，图片未识别到文本内容，请重新上传。'

// 未产生回复时，取消生成文本内容提示
export const NOT_REPLY_BY_CANCEL_TIP = '停止生成回复'

// 未生成回复内容时页面刷新回复
export const NOT_REPLY_INFO = '未生成回复内容'

// 专属客服角色回答
export const HUMAN_SERVICE_REPLY = `请联系${IS_SPECIAL_DEPLOY ? '客服' : '全景客服电话4009208393'}进行咨询。`

// 触碰误差范围值
export const TOUCH_ERROR_RANGE = 15
export const TOUCH_STROKE_MAX = 300
export const TOUCH_STROKE_MIN = 35

// 初始对话推荐问题
export const INITIAL_RECOMMEND_QUES = [
    '检测报告多久以后可以出来？',
    'PETCT 和 PETMR 的区别是什么？',
    '哪些检查项目需要空腹？',
    '查出问题后，我应该怎么就医？',
    '推荐一下比较深度的体检检查。',
    '脂肪肝还可逆吗？',
    '脑小血管检查和脑血管磁共振的区别是什么？',
    '介绍一下肝脏脂肪定量分析检查。',
    '经常头晕推荐做哪些检查？'
]

// 小景 AI 会话过期时间
export const AI_EXPIRE_DAYS = 7 * 24 * 60 * 60